let map = document.getElementById('yandexmap');
let marker;

// Функция ymaps.ready() будет вызвана, когда
// загрузятся все компоненты API, а также когда будет готово DOM-дерево.
ymaps.ready(init);
function init() {
	let myMap = new ymaps.Map('yandexmap', {
		center: [map.dataset.coordx.replace(/<\/?[^>]+>/g, ''), map.dataset.coordy.replace(/<\/?[^>]+>/g, '')],
		// Уровень масштабирования. Допустимые значения:
		// от 0 (весь мир) до 19.
		zoom: map.dataset.zoom.replace(/<\/?[^>]+>/g, ''),
	});

	marker = new ymaps.Placemark(
		[map.dataset.coordx.replace(/<\/?[^>]+>/g, ''), map.dataset.coordy.replace(/<\/?[^>]+>/g, '')],
		{
			hintContent: map.dataset.hint.replace(/<\/?[^>]+>/g, ''),
			balloonContent: map.dataset.desc.replace(/<\/?[^>]+>/g, ''),
		}
	);

	myMap.geoObjects.add(marker);
}
